const getters = {
    step: (state) => state.step,
    mobile: (state) => state.requestData.mobile,
    email: (state) => state.requestData.email,
    freeRegistrationRequestData: (state) => state.requestData,
}
export default getters
